<template>
  <Transition name="fadeHeight">
    <v-alert class="error-alert" v-if="this.$store.state.error" type="error" color="var(--app-red-1)">
      {{ this.$store.state.errorText }}
      <template v-slot:prepend>
        <v-icon> mdi-alert </v-icon>
      </template>
    </v-alert>
    <v-alert class="info-alert" v-else-if="this.$store.state.info" type="info" color="var(--app-blue-1)">
      {{ this.$store.state.infoText }}
      <template v-slot:prepend>
        <v-icon> mdi-information-outline </v-icon>
      </template>
    </v-alert>
    <v-alert class="success-alert" v-else-if="this.$store.state.success" type="success" color="var(--app-green-1)">
      {{ this.$store.state.successText }}
      <template v-slot:prepend>
        <v-icon> mdi-check </v-icon>
      </template>
    </v-alert>
  </Transition>
</template>
<script>
export default {
  data: () => ({
    alert: true,
  }),
  methods: {},
  computed: {

  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.3s;
  max-height: 100vh;
}

.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
}

.error-alert, .info-alert, .success-alert {
  z-index: 1000;
  position: fixed;
  top: 0px;
  width: 100vw;
  border-radius: 0px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;

  i {
    margin-right: 20px;
  }
}

@media screen and (max-width: 640px) {
  .error-alert {
    font-size: 16px !important;
    height: 70px;
  }
}
</style>